import styles from './MBFooter.module.scss';
import { MBLogo, PoweredByMBLogo } from '../../icons/Icons';
import GlobalContext from '../../contexts/GlobalContext';
import { ELinks } from '../../util/constants';
import { FC, useContext, useMemo } from 'react';
import { Link, useTheme } from '@mui/material';

const MBFooter: FC = () => {
    const { language, isStaffLogin, subscriberId, coBranding } = useContext(GlobalContext);
    const theme = useTheme();
    const currentYear = useMemo(() => new Date().getFullYear(), []);

    return (
        <footer className={`${styles.footer} ${coBranding.isDarkMode && styles.darkMode}`}>
            <span className={`${styles.footerLogo} ${subscriberId && styles.cobranded}`}>
                {subscriberId ? (
                    <span data-testid="mb-footer-logo-cobranded">
                        <PoweredByMBLogo
                            width={'100%'}
                            height={'100%'}
                            fillColor={theme.palette.grey[900]}
                            title={language.common.poweredByMb}
                        />
                    </span>
                ) : (
                    <span data-testid="mb-footer-logo">
                        <MBLogo width={'100%'} height={'100%'} fillColor={theme.palette.grey[900]} />
                    </span>
                )}
            </span>
            <p className={styles.copyright} data-testid="current-year">{`\u00A9${currentYear} MINDBODY, Inc.`}</p>
            <p className={styles.footerLinks}>
                <Link href={ELinks.privacyPolicy} target="_blank" data-testid="legal-privacy">
                    {`${language.legal.privacyPolicy} ${language.common.and} ${language.legal.privacyRights}`}
                </Link>
                <span className={styles.delimiter}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                {isStaffLogin ? (
                    <Link href={ELinks.termsServiceStaff} target="_blank" data-testid="legal-terms">
                        {language.legal.termsService}
                    </Link>
                ) : (
                    <Link href={ELinks.termsServiceConsumer} target="_blank" data-testid="legal-terms">
                        {language.legal.termsUse}
                    </Link>
                )}
            </p>
        </footer>
    );
};

export default MBFooter;
